import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Grid,
  TextField,
  MenuItem,
  Button,
  Typography,
  Divider,
} from "@material-ui/core";
import { useForm, Controller } from "react-hook-form";
import {
  getCityDomisili,
  getDistrictDomisili,
  getVillageDomisili,
  sendEditAlamatDomisili,
} from "../../../../../store/actions";

import { isEmpty } from "../../../../../shared/utility";

const useStyles = makeStyles((theme) => ({
  card: {
    margin: theme.spacing(3, 1.25, 1.25),
  },
  gridPadding: {
    padding: theme.spacing(0, 2, 2, 2),
  },
  field: {
    marginTop: theme.spacing(1),
  },
}));

const EditDomisili = ({
  address,
  valueEdit,
  getCityDomisili,
  getDistrictDomisili,
  getVillageDomisili,
  sendEditAlamatDomisili,
  auth,
}) => {
  const classes = useStyles();
  const history = useHistory();

  const [province, setProvince] = useState("");
  const [city, setCity] = useState("");
  const [district, setDistrict] = useState("");
  const [village, setVillage] = useState("");

  const { handleSubmit, register, errors, setValue, control } = useForm({
    shouldUnregister: false,
  });

  const handleProvince = (e) => {
    setProvince(e);
    const index = address.province.findIndex((x) => x.name === e);
    getCityDomisili(address.province[index].id);
  };

  const handleCity = (e) => {
    setCity(e);
    const index = address.city_domisili.findIndex((x) => x.name === e);
    getDistrictDomisili(address.city_domisili[index].id);
  };

  const handleDistrict = (e) => {
    setDistrict(e);
    const index = address.district_domisili.findIndex((x) => x.name === e);
    getVillageDomisili(address.district_domisili[index].id);
  };

  const onSubmit = (data) => {
    if (auth.user.id === valueEdit.UserID) {
      return sendEditAlamatDomisili(data, history, valueEdit.ID);
    }
    sendEditAlamatDomisili(data, history, valueEdit.ID, valueEdit.UserID);
  };

  useEffect(() => {
    if (!!valueEdit) {
      setValue("province", valueEdit.province);
      setValue("city", valueEdit.city);
      setValue("district", valueEdit.district);
      setValue("sub_district", valueEdit.sub_district);
      setValue("postal_code", valueEdit.postal_code);
      setValue("street", valueEdit.street);
      setValue("type", "domisili");
      setProvince(valueEdit.province);
      setCity(valueEdit.city);
      setDistrict(valueEdit.district);
      setVillage(valueEdit.sub_district);
    }
  }, [setValue, valueEdit]);

  return (
    <Card className={classes.card}>
      <CardHeader
        title={<Typography variant="h5">Form Alamat Domisili</Typography>}
      />
      <Divider />
      <form onSubmit={handleSubmit(onSubmit)}>
        <CardContent>
          <Grid container>
            <Grid item xs={6} className={classes.gridPadding}>
              {/* Provinsi */}
              <Controller
                control={control}
                name="province"
                defaultValue=""
                render={({ onChange, ref }) => (
                  <TextField
                    fullWidth
                    select
                    label="Provinsi"
                    inputRef={ref}
                    value={province}
                    onChange={(e) => {
                      onChange(e.target.value);
                      handleProvince(e.target.value);
                    }}
                    disabled={address.loadingProvince}
                    error={!!errors.province}
                    helperText={!!errors.province && errors.province.message}
                  >
                    <MenuItem value="" disabled></MenuItem>
                    {address.province.map((value) => (
                      <MenuItem value={value.name} key={value.id}>
                        {value.name}
                      </MenuItem>
                    ))}
                    {valueEdit.province !== "" && isEmpty(address.province) ? (
                      <MenuItem value={valueEdit.province}>
                        {valueEdit.province}
                      </MenuItem>
                    ) : null}
                  </TextField>
                )}
              />

              {/* Kecamatan */}
              <Controller
                control={control}
                name="district"
                defaultValue=""
                render={({ onChange, ref }) => (
                  <TextField
                    className={classes.field}
                    fullWidth
                    select
                    label="Kecamatan"
                    inputRef={ref}
                    value={district}
                    onChange={(e) => {
                      onChange(e.target.value);
                      handleDistrict(e.target.value);
                    }}
                    disabled={address.loadingDistrict_domisili}
                    error={!!errors.district}
                    helperText={!!errors.district && errors.district.message}
                  >
                    <MenuItem value="" disabled></MenuItem>
                    {address.district_domisili.map((value) => (
                      <MenuItem value={value.name} key={value.id}>
                        {value.name}
                      </MenuItem>
                    ))}
                    {valueEdit.district !== "" &&
                    isEmpty(address.district_domisili) ? (
                      <MenuItem value={valueEdit.district}>
                        {valueEdit.district}
                      </MenuItem>
                    ) : null}
                  </TextField>
                )}
              />
              <TextField
                className={classes.field}
                type="number"
                fullWidth
                name="postal_code"
                label="Kode Pos"
                inputRef={register}
                error={!!errors.postal_code}
                helperText={!!errors.postal_code && errors.postal_code.message}
              />
            </Grid>
            <Grid item xs={6} className={classes.gridPadding}>
              {/* Kota/Kabupaten */}
              <Controller
                control={control}
                name="city"
                defaultValue=""
                render={({ onChange, ref }) => (
                  <TextField
                    fullWidth
                    select
                    label="Kota/Kabupaten"
                    inputRef={ref}
                    defaultValue=""
                    value={city}
                    onChange={(e) => {
                      onChange(e.target.value);
                      handleCity(e.target.value);
                    }}
                    disabled={address.loadingCity_domisili}
                    error={!!errors.city}
                    helperText={!!errors.city && errors.city.message}
                  >
                    <MenuItem value="" disabled></MenuItem>
                    {address.city_domisili.map((value) => (
                      <MenuItem value={value.name} key={value.id}>
                        {value.name}
                      </MenuItem>
                    ))}
                    {valueEdit.city !== "" && isEmpty(address.city_domisili) ? (
                      <MenuItem value={valueEdit.city}>
                        {valueEdit.city}
                      </MenuItem>
                    ) : null}
                  </TextField>
                )}
              />

              {/* Kelurahan */}
              <Controller
                control={control}
                name="sub_district"
                defaultValue=""
                render={({ onChange, ref }) => (
                  <TextField
                    className={classes.field}
                    fullWidth
                    select
                    label="Kelurahan"
                    inputRef={ref}
                    defaultValue=""
                    value={village}
                    onChange={(e) => {
                      onChange(e.target.value);
                      setVillage(e.target.value);
                    }}
                    disabled={address.loadingVillage_domisili}
                    error={!!errors.sub_district}
                    helperText={
                      !!errors.sub_district && errors.sub_district.message
                    }
                  >
                    <MenuItem value="" disabled></MenuItem>
                    {address.village_domisili.map((value) => (
                      <MenuItem value={value.name} key={value.id}>
                        {value.name}
                      </MenuItem>
                    ))}
                    {valueEdit.sub_district !== "" &&
                    isEmpty(address.village_domisili) ? (
                      <MenuItem value={valueEdit.sub_district}>
                        {valueEdit.sub_district}
                      </MenuItem>
                    ) : null}
                  </TextField>
                )}
              />
            </Grid>
            <Grid item xs={12} className={classes.gridPadding}>
              <TextField
                className={classes.field}
                fullWidth
                multiline
                rows={5}
                variant="outlined"
                name="street"
                label="Alamat Lengkap"
                inputRef={register}
                error={!!errors.street}
                helperText={!!errors.street && errors.street.message}
              />
            </Grid>
          </Grid>
        </CardContent>
        <CardActions>
          <Button fullWidth variant="contained" color="primary" type="submit">
            Simpan Alamat Domisili
          </Button>
        </CardActions>
      </form>
    </Card>
  );
};

const mapStateToProps = (state) => {
  return {
    address: state.address,
    auth: state.auth,
  };
};

export default connect(mapStateToProps, {
  getCityDomisili,
  getDistrictDomisili,
  getVillageDomisili,
  sendEditAlamatDomisili,
})(EditDomisili);
